<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <div class="form__item">
                    <input v-model="test.main_subject" class="form__input--text" type="text" required :class="{ 'has-value': test.main_subject }"/>
                    <label class="form__label">{{$t('forms.test.main_subject')}}</label>
                </div>
                <div class="form__item">
                    <input v-model="test.sub_subject" class="form__input--text" type="text" required :class="{ 'has-value': test.sub_subject }"/>
                    <label class="form__label">{{$t('forms.test.sub_subject')}}</label>
                </div>
                <div class="form__item">
                    <input v-model="test.date_taken" class="form__input--text has-value" type="date" required />
                    <label class="form__label">{{$t('forms.test.date_taken')}}</label>
                </div>
                <div class="form__item">
                    <input v-model="test.date_closed" class="form__input--text has-value" type="date" />
                    <label class="form__label">{{$t('forms.test.date_closed')}}</label>
                </div>
                <div class="form__item">
                    <input v-model="test.price" class="form__input--text" type="number" required :class="{ 'has-value': test.price }"/>
                    <label class="form__label">{{$t('forms.test.price')}}</label>
                </div>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch} from 'vue-property-decorator';
    import Test from '@/models/Test';


    @Component
    export default class TestForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: Test, default() {
            return new Test();
        } })
        test;

        created() {
            this.errors = [];
        }

        get isSaveDisabled() {
            return !this.test.main_subject || !this.test.sub_subject || !this.test.date_taken || !this.test.price;
        }

        saveLoading = false;

        get loading () {
            return this.saveLoading;
        }

        save() {
            this.errors = [];
            this.saveLoading = true;
            this.test.save()
                .then(res => this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/dashboard/TestForm.vue